import React, { Component } from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';

import {
  USER_ROLE_RENTER,
} from 'common/userRoles';

import {
  HOUSEHOLD_APPLICATION_CATEGORY_GUARANTOR_APPLICATION,
} from 'common/householdConstants';

import {
  SCREEN_ID_APPLICATION_SUBMITTED,
} from 'client/constants/screenIds';

import branch from 'client/core/branch';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';
import allowedRoles from 'client/helpers/allowedRoles';
import SrLink from 'client/components/SrLink/SrLink';
import SrAgentLeadHighFiveModal from 'client/components/SrAgentLeadHighFiveModal';

@withTransitionHook
@allowedRoles({
  roles: [
    USER_ROLE_RENTER,
  ],
  redirectUrl: '/login',
  addRedirectQueryParam: true,
})
@branch({
  appUrl: ['env', 'APP_URL'],
})
@withScrollToTop
@withScreenId(SCREEN_ID_APPLICATION_SUBMITTED)
class ApplicationSubmittedPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Application Paid | Sunroom',
  })

  static propTypes = {
    appUrl: PropTypes.string.isRequired,
    location: PropTypes.object.isRequired,
  }

  render() {
    const { appUrl, location } = this.props;
    const locationSearch = queryString.parse(location.search);

    const isGuarantorApplication = (
      locationSearch.category === HOUSEHOLD_APPLICATION_CATEGORY_GUARANTOR_APPLICATION
    );

    return (
      <div className='page-payApplicationFee'>
        <div className='modal success confirm pay-app-fee'>
          <SrLink
            to='/faq-application'
            className='question-mark'
          />
          <div className='contentContainer'>
            <div className='highFiveAnimationContainer'>
              <SrAgentLeadHighFiveModal appUrl={appUrl} />
            </div>
            <div className='textContainer'>
              <span className='headline'>Application fee paid!</span>
              <div>
                <span className='explainer'>
                  {isGuarantorApplication
                    ? 'Sunroom will review your application and reach out to you if we have any questions.'
                    : 'Please visit your profile page to stay updated on the status of your application.'
                  }
                </span>
                <br />
                <SrLink to={isGuarantorApplication ? '/feed' : '/profile'} className='button yellow'>
                  okay
                </SrLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ApplicationSubmittedPage.displayName = 'ApplicationSubmittedPage';

export default ApplicationSubmittedPage;
